/**
 * Who you are actually contracting with, in one place.
 *
 * Both legal pages read from here, so the entity details are written down once. If any of this
 * changes — a new address, a different mailbox — it changes in this file and nowhere else.
 */
export const LEGAL = {
  /** The registered business name. GOOD BUILD is the name it trades under. */
  entity: 'Victor Chanet Software, Retail and Consulting',
  brand: 'GOOD BUILD',
  proprietor: 'Victor Chanet',
  address: 'ul. Marcina Kasprzaka 31/119, 01-234 Warszawa, Poland',
  /** Sole proprietorship on the Polish central register of business activity. */
  register: 'CEIDG, the Polish Central Registration and Information on Business',
  nip: '9512645271',
  regon: '544392504',
  country: 'Poland',

  /**
   * One mailbox, for everything: support, billing, press and data requests all arrive here.
   *
   * It has to be an address somebody actually reads. A privacy policy that names an address
   * nobody monitors is a policy that fails the moment a request arrives under it, and a second
   * address is a second place for a request to go unread — so there is only this one.
   */
  contactEmail: 'hello@goodbuild.cc',

  /** The Polish supervisory authority, for a GDPR complaint. */
  dpa: {
    name: 'Prezes Urzędu Ochrony Danych Osobowych (President of the Personal Data Protection Office)',
    address: 'ul. Stawki 2, 00-193 Warszawa, Poland',
    url: 'https://uodo.gov.pl',
  },

  /** Shown at the top of both documents. Update it whenever either one changes. */
  updated: '23 September 2026',
} as const;
